/* USER DECLARED COMPONENTS */
import Banner from "../components/banner";
import About from "../components/about";
import FeaturedListings from "../components/featured-listings";
import Blogs from "../components/blogs";
import InstagramWall from "../components/instagram-wall";
import Testimonials from "../components/testimonials";

const Homepage = () => {
  return (
    <>
      <section className="homepage">
        {/* BANNER */}
        <Banner />

        {/* ABOUT */}
        <About />

        {/* FEATURED LISTINGS */}
        <FeaturedListings />

        {/* TESTIMONIALS */}
        <Testimonials />

        {/* INSTAGRAM WALL */}
        <InstagramWall />

        {/* BLOGS */}
        <Blogs />
      </section>
    </>
  );
};

export default Homepage;
